import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      flexWrap: 'nowrap',
    },
    masterContainer: {
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
    },
    emptyPlaylistEditContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      height: '100%',
    },
    loadingContainer: {
      position: 'absolute',
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      top: 0,
      backgroundColor: 'rgba(0,0,0,0.1)',
    },
    tablePaper: {
      overflow: 'hidden',
      marginTop: theme.spacing(4),
      height: '100%',
      width: '100%',
    },
  })
);
